module.exports = __webpack_public_path__ + "static/media/pin_icon.9a2f2414.svg";